<template>
  <svg :width="size" :height="size" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10.332 1.50714L9.32489 0.5L5.33203 4.49286L1.33917 0.5L0.332031 1.50714L4.32489 5.5L0.332031 9.49286L1.33917 10.5L5.33203 6.50714L9.32489 10.5L10.332 9.49286L6.33917 5.5L10.332 1.50714Z"
      :fill="color" />
  </svg>
</template>

<script setup>
  defineProps({
    size: {
      type: String,
      default: '14px',
    },
    color: {
      type: String,
      default: 'var(--bs-primary)',
    },
  });
</script>
